import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from 'sweetalert';
import { getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from '../common_component/PageError.js';

function SetUpEcommerceInfo() {
	const [state, setstate] = useState(2);
	const { theme, dropdownStyleDark } = useTheme();

	const [subdomainName, setSubdomainName] = useState("ecom");
	const [domainName, setDomainName] = useState("");
	const [applicationId, setApplicationId] = useState("");
	const [tenantId, setTenantId] = useState("");
	const [ecommerceFlag, setEcommerceFlag] = useState(0);
	const [applicationName, setApplicationName] = useState("");
	const [tenantName, setTenantName] = useState("");

	const [isTenantAvailable, setIsTenantAvailable] = useState(null);
	const [isApplicationAvailable, setIsApplicationAvailable] = useState(null);
	const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false)

	var page_name = "set-up-ecommerce-info";

	const { user, read, write, visibility, organization_id } = useAuthData(page_name);

	const loaderstyle = {
		display: "block",
		marginLeft: "auto",
		marginRight: "auto",
		marginTop: "auto",
		marginBottom: "auto",
	};

	useEffect(() => {
		async function getEcommercedetails() {
			var object = {};
			object.email = user.email;

			const response = await fetch(
				`${process.env.REACT_APP_SERVER_URL}/get-ecommerce-set-up-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
			);
			const body = await response.json();
			if (body.operation === "success") {
				setstate(1);
				if (body.data.length > 0) {
					setEcommerceFlag(1);
					setApplicationName(body.data[0].application_name);
					setTenantName(body.data[0].tenant_name);
					setSubdomainName(body.data[0].subdomain_name);
					setDomainName(body.data[0].domain_name)
					setTenantId(body.data[0].tenant_id)
					setApplicationId(body.data[0].application_id)
				}
			}
		}
		if (read || write) {
			(user.email && visibility) && getEcommercedetails();
		}
	}, [user, visibility, read, write])

	const updateSetupInfo = () => {
		// var id = user.email;

		if (subdomainName === "") {
			swal("Oops!", "Subdomain Name can't be empty", "warning");
			return false;
		}
		if (tenantName === "") {
			swal("Oops!", "Tenant Name can't be empty", "warning");
			return false;
		}
		if (applicationName === "") {
			swal("Oops!", "Application Name can't be empty", "warning");
			return false;
		}
		if (isTenantAvailable === null) {
			swal("Oops!", "Check tenant availability.", "warning");
			return false;
		}
		else if (isTenantAvailable === false) {
			swal("Oops!", "Tenant name is already taken.", "warning");
			return false;
		}
		if (isApplicationAvailable === null) {
			swal("Oops!", "Check application availability.", "warning");
			return false;
		}
		else if (isApplicationAvailable === false) {
			swal("Oops!", "Application name is already taken.", "warning");
			return false;
		}

		var values = { "subdomain_name": subdomainName, "domain_name": domainName, "tenant_name": tenantName, "application_name": applicationName, "page_name": page_name, "organization_id": organization_id };
		setMainSubmitButtonState(true)
		var headers = {
			headers: {
				"Content-Type": "application/json",
				"Accept": "*/*",
				"token": getCookie("access_token")
			}
		}
		axios.post(`${process.env.REACT_APP_SERVER_URL}/add-ecommerce-set-up-info`, values, headers).then((res) => {
			setMainSubmitButtonState(false)
			if (res.data && res.data.operation === "success") {
				swal("Great!", "Ecommerce SetUp Info saved successfully!", "success").then((value) => {
					window.location.reload();
				});
			}
			else if (res.data.operation === "danger" && res.data.message === "same_subdomain_name") {
				swal("Oops!", "Same subdomain already present for ecommerce!", "warning");
			}
			else if (res.data.operation === "danger" && res.data.message === "same_tenant_name") {
				swal("Oops!", "Same tenant name already present for ecommerce!", "warning");
			}
			else if (res.data.operation === "danger" && res.data.message === "same_application_name") {
				swal("Oops!", "Same application name already present for ecommerce!", "warning");
			}
			else {
				swal("Oops!", "Something went wrong!", "error");
			}
		});
	}

	const checkTenantAvailability = async () => {
		try {
			var values = { "tenant_name": tenantName, "page_name": page_name, "organization_id": organization_id };
			setMainSubmitButtonState(true)
			var headers = {
				headers: {
					"Content-Type": "application/json",
					"Accept": "*/*",
					"token": getCookie("access_token")
				}
			}
			axios.post(`${process.env.REACT_APP_SERVER_URL}/check-tenant-availability`, values, headers).then((res) => {
				setMainSubmitButtonState(false)
				if (res.data && res.data.operation === "success") {
					setIsTenantAvailable(false);
					//setTenantError(null);
				}
				else {
					setIsTenantAvailable(true);
					//setTenantError('An error occurred. Please check your connection.');
				}
			});
		} catch (error) {
			///
		}
	};

	const checkApplicationAvailability = async () => {
		try {
			var values = { "application_name": applicationName, "page_name": page_name, "organization_id": organization_id };
			setMainSubmitButtonState(true)
			var headers = {
				headers: {
					"Content-Type": "application/json",
					"Accept": "*/*",
					"token": getCookie("access_token")
				}
			}
			axios.post(`${process.env.REACT_APP_SERVER_URL}/check-application-availability`, values, headers).then((res) => {
				setMainSubmitButtonState(false)
				if (res.data && res.data.operation === "success") {
					setIsApplicationAvailable(false);
				}
				else {
					setIsApplicationAvailable(true);
				}
			});
		} catch (error) {
			console.log(error);
		}
	};

	return (
		<>
			<div>
				<div className="d-flex flex-stack mb-5">
					<h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Set up ecommerce information</h1>
				</div>
				<div>
					{state === 1 ?
						<div className="card">
							<div className="card-body">
								<div className="row mb-6">
									<label className="col-lg-4 col-form-label required fw-bold fs-6">Subdomain Name</label>
									<div className="col-lg-8">
										<div className="row">
											<div className="col-lg-6 fv-row">
												<input type="text" className="form-control" placeholder="Enter Subdomain name" value={subdomainName} onChange={(e) => { setSubdomainName(e.target.value) }} />
												<span id="firstname" className="text-danger font-weight-bold"></span>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb-6">
									<label className="col-lg-4 col-form-label fw-bold fs-6">Domain Name</label>
									<div className="col-lg-8">
										<div className="row">
											<div className="col-lg-6 fv-row">
												<input type="text" className="form-control" disabled={ecommerceFlag === true} readOnly={ecommerceFlag === true} value={domainName} onChange={(e) => { setDomainName(e.target.value) }} />
												<span id="firstname" className="text-danger font-weight-bold"></span>
											</div>
										</div>
									</div>
								</div>
								<div className="row mb-6">
									<label className="col-lg-4 col-form-label required fw-bold fs-6">Tenant Name</label>
									<div className="col-lg-8">
										<div className="row">
											<div className="col-lg-6 fv-row">
												<input type="text" className="form-control" placeholder="Enter Tenant name" value={tenantName} onChange={(e) => { setTenantName(e.target.value) }} disabled={ecommerceFlag === true} readOnly={ecommerceFlag === true} onBlur={checkTenantAvailability} />
												{isTenantAvailable === true ? <span className="text-success font-weight-bold">Tenant name is available!</span>
													: isTenantAvailable === false && <span className="text-danger font-weight-bold">Tenant name is already taken.</span>}
											</div>
										</div>
									</div>
								</div>
								<div className="row mb-6">
									<label className="col-lg-4 col-form-label required fw-bold fs-6">Application Name</label>
									<div className="col-lg-8">
										<div className="row">
											<div className="col-lg-6 fv-row">
												<input type="text" className="form-control" placeholder="Enter Application name" value={applicationName} onChange={(e) => { setApplicationName(e.target.value) }} disabled={ecommerceFlag === true} readOnly={ecommerceFlag === true} onBlur={checkApplicationAvailability} />
												{isApplicationAvailable === true ? <span className="text-success font-weight-bold">Application name is available!</span>
													: isApplicationAvailable === false && <span className="text-danger font-weight-bold">Application name is already taken.</span>}
											</div>
										</div>
									</div>
								</div>
								{applicationId !== "" &&
									<div className="row mb-6">
										<label className="col-lg-4 col-form-label required fw-bold fs-6">Application Id</label>
										<div className="col-lg-8">
											<div className="row">
												<div className="col-lg-6 fv-row">
													<input type="text" className="form-control" value={applicationId} disabled={ecommerceFlag === true} readOnly={ecommerceFlag === true} />
												</div>
											</div>
										</div>
									</div>}
								{tenantId !== "" &&
									<div className="row mb-6">
										<label className="col-lg-4 col-form-label required fw-bold fs-6">Tenant Id</label>
										<div className="col-lg-8">
											<div className="row">
												<div className="col-lg-6 fv-row">
													<input type="text" className="form-control" value={tenantId} disabled={ecommerceFlag === true} readOnly={ecommerceFlag === true} />

												</div>
											</div>
										</div>
									</div>}
							</div>
							<div className="card-footer d-flex justify-content-end py-6 px-9">
								{
									(write && !ecommerceFlag) &&
									<button type="button" className="btn btn-primary rounded" onClick={updateSetupInfo} data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">Save Changes</span>
										<span className="indicator-progress">Please wait...
											<span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
								}
							</div>
						</div>
						:
						<div className="card modal-body pt-0 pb-15 px-5 px-xl-20">
							<br />

							{state === 2 ?
								<img src="/images/loader-06.svg" alt="" style={loaderstyle} />
								:
								<PageError />
							}
							<br />
						</div>
					}
				</div>
			</div >
		</>
	);
}
export default SetUpEcommerceInfo;